'use client';

import { useRef, useLayoutEffect } from "react";
import { TOAST_NOTIFICATION_ANIMATION_DURATION } from "../../../molecules/ToastNotification/utils/constants.js";
function getElement(id) {
  return document.getElementById(id) ?? null;
}
function useSmoothRepositioning(toastNotifications) {
  const positionsRef = useRef(/* @__PURE__ */ new Map());
  const animatingRef = useRef(/* @__PURE__ */ new Set());
  const recordPositionsRef = useRef(() => {
  });
  useLayoutEffect(() => {
    toastNotifications.forEach(({ id }) => {
      const el = getElement(id);
      if (!el) return;
      const prevTop = positionsRef.current.get(id);
      const newTop = el.getBoundingClientRect().top;
      const delta = prevTop !== void 0 ? prevTop - newTop : 0;
      if (delta === 0 || animatingRef.current.has(id)) return;
      animatingRef.current.add(id);
      const prevTransition = el.style.transition;
      el.style.cssText = `transition: ${prevTransition}, transform 0ms; transform: translateY(${delta}px);`;
      requestAnimationFrame(() => {
        el.style.cssText = `transition: ${prevTransition}, transform ${TOAST_NOTIFICATION_ANIMATION_DURATION}ms ease-in-out;`;
        const handleTransitionEnd = () => {
          el.style.transition = prevTransition;
          animatingRef.current.delete(id);
        };
        el.addEventListener("transitionend", handleTransitionEnd, {
          once: true
        });
      });
    });
    recordPositionsRef.current = () => {
      toastNotifications.forEach(({ id }) => {
        const el = getElement(id);
        if (el) {
          const { top } = el.getBoundingClientRect();
          positionsRef.current.set(id, top);
        }
      });
    };
  }, [toastNotifications]);
  return recordPositionsRef;
}
export {
  useSmoothRepositioning
};
